import BorderWrapper from "../../../components/ui/wrappers/BorderWrapper";

const CardRelation = ({ relation, linkElts }) => {
    const getInitials = (fullName) => {
        return fullName.split(" ").map(str => str[0]).join("");
    }

    return <BorderWrapper tailwindClass={"p-3 w-64"}>
        {/* On affiche les initiales du collègue si la photo n'est pas renseignée */}
        {relation.image ?
            <img className={"mb-4 object-cover w-full h-72"} src={relation.image} alt={"A wonderful worker"} />
            :
            <div className={"mb-4 bg-gray-200 flex items-center justify-center object-cover w-full h-72"} src={relation.image} alt={"A wonderful worker"}>
                <p className="text-secondary text-5xl">{getInitials(relation.name)}</p>
            </div>
        }
        <div className={"mb-5"}>
            <h3 className={"mb-2 text-secondary text-xl font-semibold"}>{relation.name}</h3>
            <p className={"font-semibold text-lg"}>{relation.job}</p>
        </div>
        <div className={"flex gap-x-5"}>
            {linkElts &&
                linkElts.map((elt, index) => elt)
            }
        </div>
    </BorderWrapper>

}

export default CardRelation;